import { useState } from 'react';
import { useWindowStore } from '@/stores/windowStore';
import { StartMenu } from './StartMenu';
import { SystemTray } from './SystemTray';
import { WindowButton } from './WindowButton';

export function Taskbar() {
  const [startMenuOpen, setStartMenuOpen] = useState(false);
  const { windows, getActiveWindow } = useWindowStore();
  const activeWindow = getActiveWindow();

  return (
    <>
      {/* Start Menu */}
      {startMenuOpen && <StartMenu onClose={() => setStartMenuOpen(false)} />}

      {/* Taskbar */}
      <div className="taskbar absolute bottom-0 left-0 right-0 h-10 bg-[#c0c0c0] border-t-2 border-white flex items-center px-1 z-[10000]">
        {/* Start Button */}
        <button
          onClick={() => setStartMenuOpen(!startMenuOpen)}
          className="win98-button px-3 py-1 flex items-center gap-2 font-bold text-black"
        >
          <span className="text-lg">⊞</span>
          Start
        </button>

        {/* Window Buttons Area */}
        <div className="flex-1 mx-2 h-8 bg-[#808080] border border-[#404040] flex items-center gap-1 px-2 overflow-x-auto">
          {windows.map((window) => (
            <WindowButton
              key={window.id}
              window={window}
              isActive={activeWindow?.id === window.id}
            />
          ))}
        </div>

        {/* System Tray */}
        <SystemTray />
      </div>
    </>
  );
}
